import { StrictMode, lazy, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom'
import { useProfileStore } from '../store/profileStore'
import './app.css'

const Home              = lazy(() => import('../pages/Home'))
const GameSelect        = lazy(() => import('../pages/GameSelect'))
const ParentalDashboard = lazy(() => import('../pages/ParentalDashboard'))
const QuizGame          = lazy(() => import('../games/quiz/QuizGame'))
const MazeGame          = lazy(() => import('../games/maze/MazeGame'))
const MemoryGame        = lazy(() => import('../games/memory/MemoryGame'))
const TicTacToe         = lazy(() => import('../games/tictactoe/TicTacToe'))
const WordPuzzleGame    = lazy(() => import('../games/wordpuzzle/WordPuzzleGame'))
const Login             = lazy(() => import('../pages/Login'))
const MathGame          = lazy(() => import('../games/math/MathGame'))
const WhackAMole        = lazy(() => import('../games/whackamole/WhackAMole'))
const BubbleShooter     = lazy(() => import('../games/bubbleshoooter/BubbleShooter'))
const KitchenSink       = lazy(() => import('../pages/KitchenSink'))

function Spinner() {
  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="w-10 h-10 border-4 border-indigo-400 border-t-transparent rounded-full animate-spin" />
    </div>
  )
}

function RequireProfile({ children }) {
  const profile = useProfileStore((s) => s.profile)
  return profile ? children : <Navigate to="/" replace />
}

const router = createBrowserRouter([
  { path: '/',            element: <Home /> },
  { path: '/games',       element: <RequireProfile><GameSelect /></RequireProfile> },
  { path: '/games/quiz',  element: <RequireProfile><QuizGame /></RequireProfile> },
  { path: '/games/maze',   element: <RequireProfile><MazeGame /></RequireProfile> },
  { path: '/games/memory',    element: <RequireProfile><MemoryGame /></RequireProfile> },
  { path: '/games/tictactoe',   element: <RequireProfile><TicTacToe /></RequireProfile> },
  { path: '/games/word-puzzle', element: <RequireProfile><WordPuzzleGame /></RequireProfile> },
  { path: '/games/math',        element: <RequireProfile><MathGame /></RequireProfile> },
  { path: '/games/whack-a-mole',    element: <RequireProfile><WhackAMole /></RequireProfile> },
  { path: '/games/bubble-shooter', element: <RequireProfile><BubbleShooter /></RequireProfile> },
  { path: '/parent',      element: <ParentalDashboard /> },
  { path: '/login',        element: <Login /> },
  ...(import.meta.env.DEV ? [{ path: '/kitchen-sink', element: <KitchenSink /> }] : []),
  { path: '*',             element: <Navigate to="/" replace /> },
], { basename: window.Capacitor?.isNativePlatform?.() ? '/' : '/app' })

const container = document.getElementById('app')
const root = container._reactRoot ?? createRoot(container)
container._reactRoot = root
root.render(
  <StrictMode>
    <Suspense fallback={<Spinner />}>
      <RouterProvider router={router} />
    </Suspense>
  </StrictMode>
)
